import { useEffect } from 'react';
import {
    constructUriSearchStr,
    encodeBoundsToStr,
    encodeOriginToStr,
} from '../TopbarDesktopSearchPanel.helpers';
import { parse } from '../../../../../util/urlHelpers';
import { useIntl } from 'react-intl';
import { queryParamsToExcludeForSearchPage } from '../../../../../containers/SearchPage/SearchPage.helpers';
/**
 * Update search url params on listing tab change
 */
export const useListingsTabs = ({
    listingType,
    urlParams,
    initialLocation,
    distance,
    finalFormRef,
    setSearchURL,
    urlParamsStr,
}) => {
    const intl = useIntl();

    useEffect(() => {
        /**
         * if there in no search params in the url
         * set searchUrl to initialValues if any;
         */
        const searchParams =
            urlParams && urlParams.bounds && urlParams.address
                ? urlParams
                : initialLocation &&
                  initialLocation.selectedPlace &&
                  initialLocation.selectedPlace.bounds &&
                  initialLocation.selectedPlace.origin
                ? {
                      ...initialLocation.selectedPlace,
                      distance,
                      bounds: encodeBoundsToStr(initialLocation.selectedPlace.bounds),
                      origin: encodeOriginToStr(initialLocation.selectedPlace.origin),
                  }
                : null;

        const finalForm = finalFormRef.current;

        if (!searchParams && finalForm) {
            return finalForm.change('location', undefined);
        } else if (searchParams) {
            setSearchURL(prevState => {
                const { listingType: prevListingType } = parse(prevState);
                /**
                 * remove sort & extraSort search params
                 * on listing tab change; set sorting by
                 * origin - available for both types
                 */
                const listingTypeChanged = prevListingType !== listingType;

                const noSortParamsMaybe = listingTypeChanged
                    ? {
                          ...queryParamsToExcludeForSearchPage,
                      }
                    : {};

                return constructUriSearchStr(
                    {
                        ...searchParams,
                        ...noSortParamsMaybe,
                        listingType,
                        page: 1,
                    },
                    intl
                );
            });
        }
        /**
         * urlParamsStr = e.g. react on mapView change at the SP
         */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlParamsStr, listingType]);
};
